import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { ResidentialFlatRates } from '../types/admin';

interface FlatRatesResponse {
  success: boolean;
  data: ResidentialFlatRates;
}

export function useResidentialFlatRates(orgId: string) {
  const [flatRates, setFlatRates] = useState<ResidentialFlatRates | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get<FlatRatesResponse>(`/org-admin/${orgId}/residential-flat-rates`)
      .then(res => {
        if (!cancelled) {
          setFlatRates(res.data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load residential flat rates');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [orgId]);

  const updateFlatRates = useCallback(
    async (data: ResidentialFlatRates) => {
      const res = await api.put<FlatRatesResponse>(`/org-admin/${orgId}/residential-flat-rates`, data);
      setFlatRates(res.data);
      return res.data;
    },
    [orgId],
  );

  return { flatRates, loading, error, updateFlatRates };
}
